/* Tactical X — native Shopify video controls with optional per-clip muted autoplay. */
(() => {
  document.addEventListener('click', event => {
    const button = event.target.closest('.gx11-film-play');
    if (!button) return;
    const frame = button.closest('[data-gx10-video]');
    const video = frame?.querySelector('video');
    if (!video) return;
    document.querySelectorAll('.gx11-film-screen.is-playing video').forEach(other => {
      if (other !== video) other.pause();
    });
    video.muted = false;
    video.loop = false;
    video.controls = true;
    video.play().then(() => frame.classList.add('is-playing')).catch(() => {
      frame.classList.remove('is-playing');
    });
  });
  ['pause', 'ended'].forEach(type => document.addEventListener(type, event => {
    const video = event.target;
    if (!video.matches?.('.gx11-film-video')) return;
    video.closest('[data-gx10-video]')?.classList.remove('is-playing');
    if (type === 'ended') video.currentTime = 0;
  }, true));
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  const clips = [...document.querySelectorAll('[data-gx10-autoplay]')];
  if (!clips.length) return;
  const observer = new IntersectionObserver(entries => entries.forEach(({target, intersectionRatio}) => {
    const video = target.querySelector('video');
    if (!video) return;
    if (intersectionRatio > .6 && video.paused) {
      video.muted = true;
      video.loop = true;
      video.controls = false;
      video.play().then(() => target.classList.add('is-playing')).catch(() => target.classList.remove('is-playing'));
    } else if (intersectionRatio < .1 && !video.paused) {
      video.pause();
    }
  }), {threshold:[0,.1,.65]});
  clips.forEach(clip => observer.observe(clip));
})();
